<div class="detail-tab">

  <!-- Info Grid -->
  <div class="info-section">
    <h2 class="section-title">Class Information</h2>
    <div class="info-grid">

      <div class="info-item">
        <span class="info-label">Class Name</span>
        <span class="info-value">{{ classEntity.name }}</span>
      </div>

      <div class="info-item">
        <span class="info-label">Start Date</span>
        <span class="info-value">{{ scheduleStartDate }}</span>
      </div>

      <div class="info-item">
        <span class="info-label">End Date</span>
        <span class="info-value">{{ scheduleEndDate }}</span>
      </div>

      <div class="info-item">
        <span class="info-label">Trainer(s)</span>
        <span class="info-value">{{ trainerNames }}</span>
      </div>

    </div>
  </div>

  <!-- Action buttons -->
  <div class="actions-section" *ngIf="isStudent">
    <h2 class="section-title">Lab Resources</h2>

    <!-- Tab selector (only shown when both resources exist) -->
    <div class="lr-tabs" *ngIf="hasVmResource && hasAccResource">
      <button class="lr-tab" [class.lr-tab--active]="activeResourceTab === 'vm'" (click)="activeResourceTab = 'vm'">
        <mat-icon class="lr-tab-icon">computer</mat-icon>
        Virtual Machine
      </button>
      <button class="lr-tab" [class.lr-tab--active]="activeResourceTab === 'acc'" (click)="activeResourceTab = 'acc'">
        <mat-icon class="lr-tab-icon">manage_accounts</mat-icon>
        Cloud Account
        <span class="lr-tab-badge lr-tab-badge--active" *ngIf="accCredState === 'active'">Ready</span>
        <span class="lr-tab-badge lr-tab-badge--creating"
          *ngIf="accCredState === 'creating' || accCredState === 'initiating' || accCredState === 'fetching'">
          <mat-spinner diameter="10" class="lr-tab-spinner"></mat-spinner>
        </span>
        <span class="lr-tab-badge lr-tab-badge--failed" *ngIf="accCredState === 'failed'">!</span>
      </button>
    </div>

    <!-- ══ VM TAB ══ -->
    <div class="lr-tab-content" *ngIf="hasVmResource && (activeResourceTab === 'vm' || !hasAccResource)">
      <div class="vm-resource-grid">

        <!-- Card 1: Template Info — shared component -->
        <app-template-info-card [data]="templateInfoCardData"></app-template-info-card>

        <!-- Card 2: VM Actions -->
        <mat-card class="acc-card vmt-action-card-student">
          <mat-card-header>
            <mat-card-title class="acc-card-title-row">
              <mat-icon class="acc-card-title-icon">computer</mat-icon>
              Lab Access
            </mat-card-title>
            <mat-card-subtitle>Connect to your virtual machine</mat-card-subtitle>
          </mat-card-header>
          <mat-card-content class="acc-actions-content">

            <!-- loading state -->
            <div *ngIf="vmStatusLoading" class="acc-action-body acc-center">
              <mat-spinner diameter="36"></mat-spinner>
              <p class="acc-state-title" style="margin-top:12px;">Checking VM Status…</p>
            </div>

            <!-- not_created state -->
            <div *ngIf="!vmStatusLoading && vmProvisionState === 'not_created'" class="acc-action-body acc-center">
              <mat-icon class="acc-state-icon">cloud_queue</mat-icon>
              <p class="acc-state-title">Lab VM Not Started</p>
              <p class="acc-state-sub">Your virtual machine hasn't been accessed yet. Click below to begin the
                provisioning process.</p>
              <button mat-flat-button color="primary" [disabled]="isProvisioningTrigger" (click)="triggerProvision()">
                <mat-spinner *ngIf="isProvisioningTrigger" diameter="18" class="btn-spinner"></mat-spinner>
                <mat-icon *ngIf="!isProvisioningTrigger">add_circle</mat-icon>
                {{ isProvisioningTrigger ? 'Starting…' : 'Prepare VM' }}
              </button>
            </div>

            <!-- creating state -->
            <div *ngIf="vmProvisionState === 'creating'" class="acc-action-body acc-center">
              <mat-progress-bar mode="indeterminate" class="acc-progress-bar"></mat-progress-bar>
              <p class="acc-state-title">Preparing Your VM…</p>
              <p class="acc-state-sub">Your virtual machine is being provisioned. This takes a few minutes — this page
                will update automatically.</p>
            </div>

            <!-- ready state -->
            <div *ngIf="vmProvisionState === 'ready'" class="acc-action-body acc-center">
              <mat-icon class="acc-state-icon acc-icon-success">check_circle</mat-icon>
              <p class="acc-state-title">VM Ready</p>
              <p class="acc-state-sub">Your virtual machine is provisioned and ready. Click Launch to open your remote
                desktop session.</p>
              <button mat-flat-button color="primary" [disabled]="isLaunching" (click)="openVmSession()">
                <mat-spinner *ngIf="isLaunching" diameter="18" class="btn-spinner"></mat-spinner>
                <mat-icon *ngIf="!isLaunching">launch</mat-icon>
                {{ isLaunching ? 'Launching…' : 'Launch' }}
              </button>
            </div>

            <!-- failed state -->
            <div *ngIf="vmProvisionState === 'failed'" class="acc-action-body acc-center">
              <mat-icon class="acc-state-icon acc-icon-error">cancel</mat-icon>
              <p class="acc-state-title">Provisioning Failed</p>
              <p class="acc-state-sub">An error occurred while setting up your VM. You can retry — if the problem
                persists, contact your trainer.</p>
              <button mat-stroked-button color="warn" [disabled]="isProvisioningTrigger" (click)="triggerProvision()">
                <mat-spinner *ngIf="isProvisioningTrigger" diameter="18" class="btn-spinner"></mat-spinner>
                <mat-icon *ngIf="!isProvisioningTrigger">refresh</mat-icon>
                {{ isProvisioningTrigger ? 'Retrying…' : 'Retry' }}
              </button>
            </div>

          </mat-card-content>
        </mat-card>

      </div><!-- /vm-resource-grid -->
    </div><!-- /VM tab -->

    <!-- ══ ACC TAB ══ -->
    <div class="lr-tab-content" *ngIf="hasAccResource && (activeResourceTab === 'acc' || !hasVmResource)">
      <div class="acc-resource-grid" [class.acc-resource-grid--3col]="accCredState === 'active'">

        <!-- Card 1: Info -->
        <mat-card class="acc-card acc-info-card">
          <mat-card-header>
            <mat-card-title class="acc-card-title-row">
              <mat-icon class="acc-card-title-icon">manage_accounts</mat-icon>
              Cloud Account
            </mat-card-title>
            <mat-card-subtitle>Your Azure AD user account for this class</mat-card-subtitle>
          </mat-card-header>
          <mat-card-content class="acc-info-content">
            <div class="acc-info-grid">
              <div class="acc-info-item">
                <span class="acc-info-label">Account Type</span>
                <span class="acc-info-value">Azure Active Directory</span>
              </div>
              <div class="acc-info-item">
                <span class="acc-info-label">Class</span>
                <span class="acc-info-value mono">{{ classEntity.name }}</span>
              </div>
            </div>
            <!-- Status chip -->
            <div class="acc-status-chip-row">
              <span class="acc-status-chip acc-chip-pending"
                *ngIf="accCredState === null || accCredState === 'fetching'">
                <mat-icon class="chip-icon">schedule</mat-icon> Not Started
              </span>
              <span class="acc-status-chip acc-chip-creating"
                *ngIf="accCredState === 'initiating' || accCredState === 'creating'">
                <mat-spinner diameter="12" class="chip-spinner"></mat-spinner> Provisioning…
              </span>
              <span class="acc-status-chip acc-chip-active" *ngIf="accCredState === 'active'">
                <mat-icon class="chip-icon">check_circle</mat-icon> Active
              </span>
              <span class="acc-status-chip acc-chip-failed" *ngIf="accCredState === 'failed'">
                <mat-icon class="chip-icon">cancel</mat-icon> Failed
              </span>
            </div>
          </mat-card-content>
        </mat-card>

        <!-- Card 2: Credentials (active only) -->
        <mat-card *ngIf="accCredState === 'active'" class="acc-card acc-creds-card">
          <mat-card-header>
            <mat-card-title class="acc-card-title-row">
              <mat-icon class="acc-card-title-icon">vpn_key</mat-icon>
              Credentials
            </mat-card-title>
            <mat-card-subtitle>Use these to sign in to Azure services</mat-card-subtitle>
          </mat-card-header>
          <mat-card-content class="acc-creds-content">

            <!-- UPN row -->
            <div class="acc-cred-row" *ngIf="accCredentials?.username">
              <span class="acc-cred-label">Username (UPN)</span>
              <div class="acc-cred-value-row">
                <span class="acc-cred-value mono">{{ accCredentials!.username }}</span>
                <button mat-icon-button matTooltip="Copy username" (click)="copyToClipboard(accCredentials!.username)">
                  <mat-icon>content_copy</mat-icon>
                </button>
              </div>
            </div>

            <!-- TAP row -->
            <div class="acc-cred-row" *ngIf="accCredentials?.temporaryAccessPass">
              <span class="acc-cred-label">Temp. Access Pass</span>
              <div class="acc-cred-value-row">
                <span class="acc-cred-value mono">{{ accCredentials!.temporaryAccessPass }}</span>
                <button mat-icon-button matTooltip="Copy TAP"
                  (click)="copyToClipboard(accCredentials!.temporaryAccessPass)">
                  <mat-icon>content_copy</mat-icon>
                </button>
              </div>
            </div>

            <!-- Password row (fallback if TAP not present) -->
            <div class="acc-cred-row" *ngIf="accCredentials?.password && !accCredentials?.temporaryAccessPass">
              <span class="acc-cred-label">Password</span>
              <div class="acc-cred-value-row">
                <span class="acc-cred-value mono">{{ accCredentials!.password }}</span>
                <button mat-icon-button matTooltip="Copy password" (click)="copyToClipboard(accCredentials!.password)">
                  <mat-icon>content_copy</mat-icon>
                </button>
              </div>
            </div>

          </mat-card-content>
        </mat-card>

        <!-- Card 3: Actions -->
        <mat-card class="acc-card acc-actions-card">
          <mat-card-header>
            <mat-card-title class="acc-card-title-row">
              <mat-icon class="acc-card-title-icon">settings</mat-icon>
              Actions
            </mat-card-title>
          </mat-card-header>
          <mat-card-content class="acc-actions-content">

            <!-- null / fetching → Get Credentials -->
            <div *ngIf="accCredState === null || accCredState === 'fetching'" class="acc-action-body acc-center">
              <mat-icon class="acc-state-icon">cloud_queue</mat-icon>
              <p class="acc-state-title">Get Cloud Credentials</p>
              <p class="acc-state-sub">Retrieve your Azure account credentials to access the Azure Portal and lab
                resources.</p>
              <button mat-flat-button color="primary" [disabled]="accCredState === 'fetching'"
                (click)="triggerGetCredentials()">
                <mat-spinner *ngIf="accCredState === 'fetching'" diameter="18" class="btn-spinner"></mat-spinner>
                <mat-icon *ngIf="accCredState !== 'fetching'">key</mat-icon>
                {{ accCredState === 'fetching' ? 'Checking…' : 'Get Credentials' }}
              </button>
            </div>

            <!-- initiating / creating → Provisioning in progress -->
            <div *ngIf="accCredState === 'initiating' || accCredState === 'creating'"
              class="acc-action-body acc-center">
              <mat-progress-bar mode="indeterminate" class="acc-progress-bar"></mat-progress-bar>
              <p class="acc-state-title">Provisioning Azure Account…</p>
              <p class="acc-state-sub">Creating your Azure AD account. Checking every 5 s — this usually completes
                within 2 minutes.</p>
            </div>

            <!-- active → Portal + Regen TAP -->
            <div *ngIf="accCredState === 'active'" class="acc-action-body acc-center">
              <mat-icon class="acc-state-icon acc-icon-success">check_circle</mat-icon>
              <p class="acc-state-title">Account Ready</p>
              <p class="acc-state-sub">Your Azure AD account is active. Use the credentials to sign in.</p>
              <div class="acc-btn-row">
                <button mat-stroked-button color="primary" [disabled]="isRegeneratingTap" (click)="openAzurePortal()"
                  matTooltip="Open Azure Portal in a new tab">
                  <mat-icon>open_in_new</mat-icon>
                  Open Portal
                </button>
                <button mat-stroked-button [disabled]="isRegeneratingTap" (click)="regenerateTap()"
                  matTooltip="Generate a new Temporary Access Pass">
                  <mat-spinner *ngIf="isRegeneratingTap" diameter="18" class="btn-spinner"></mat-spinner>
                  <mat-icon *ngIf="!isRegeneratingTap">refresh</mat-icon>
                  {{ isRegeneratingTap ? 'Regenerating…' : 'Regenerate TAP' }}
                </button>
              </div>
            </div>

            <!-- failed → Error + Retry -->
            <div *ngIf="accCredState === 'failed'" class="acc-action-body acc-center">
              <mat-icon class="acc-state-icon acc-icon-error">cancel</mat-icon>
              <p class="acc-state-title">Provisioning Failed</p>
              <p class="acc-state-sub">{{ accErrorMessage }}</p>
              <button mat-stroked-button color="warn" (click)="retryAccCredentials()">
                <mat-icon>replay</mat-icon>
                Retry
              </button>
            </div>

          </mat-card-content>
        </mat-card>

      </div><!-- /acc-resource-grid -->
    </div><!-- /ACC tab -->

  </div>

</div>
